
import testingCommisionaAtionTypes from '../../actions/TestingCommission/TCActionTypes';

const basicDetailsMandatoryFields = [
    { type: 'Service Type', name: 'service', valueFilled: false, isMandatory: true },
    { type: 'Vendor Name', name: 'vendorName', valueFilled: false, isMandatory: true },
    { type: 'Type Code', name: 'typeCode', valueFilled: false, isMandatory: true },
    { type: 'Asset Description', name: 'assetDescription', valueFilled: false, isMandatory: true },
    { type: 'Work Group', name: 'workGroup', valueFilled: false, isMandatory: true },
    { type: 'T&C Start Date', name: 'tCStartDate', valueFilled: false, isMandatory: true },
];

const initialState = {
    currentPage: 'Basic Details',
    currentPageMandatoryFields: basicDetailsMandatoryFields,
    isSaved: false,
    vendornotify: false,
    basicDetailsSavedData: '',
    editRowData: '',
};

const stepperReducer = (state = initialState, action) => {
    switch (action.type) {
        case testingCommisionaAtionTypes.NEXT_PAGE:
            return {
                ...state,
                ...action.payload,
            };
        case testingCommisionaAtionTypes.PREVIOUS_PAGE:
            return {
                ...state,
                ...action.payload,
            };
        case testingCommisionaAtionTypes.SAVE_PAGE:
            return {
                ...state,
                isSaved: action.payload.isSaved, // Update isSaved correctly
                basicDetailsSavedData: action.payload.basicDetailsSavedData // Update basicDetailsSavedData
            };
        case testingCommisionaAtionTypes.SET_BASIC_DETAILS_MANDATORY_FIELDS:
            return {
                ...state,
                currentPageMandatoryFields: action.payload
            };
        default:
            return state;
    }
};

export default stepperReducer;
